import { BaseInterior } from './BaseInterior';
import { socketManager } from '../socket/SocketManager';

export class PoliceInterior extends BaseInterior {
  render(): void {
    this.drawRoom(0x2a3a4a, 0x4a5a6a);
    this.addExitButton();
    this.addTitle('Commissariat Central');

    const { width, height } = this.scene.scale;
    const pi = this.stateData?.policeInfo;

    if (!pi) {
      this.addLabel(width / 2, height / 2, 'Acces limite', '#ff4444', '16px');
      return;
    }

    let y = 100;
    const leftCol = 80;

    // Global alert level
    this.addLabel(leftCol, y, 'Niveau d\'alerte global:', '#ffffff', '14px');
    y += 20;
    const alertColor = pi.alertLevel < 30 ? 0x4caf50 : pi.alertLevel < 60 ? 0xff9800 : 0xff4444;
    this.drawProgressBar(leftCol, y, 250, 18, pi.alertLevel / 100, 0x333333, alertColor);
    this.addLabel(leftCol + 260, y, `${pi.alertLevel}%`, '#ffffff', '14px');
    y += 35;

    // Watched buildings
    if (pi.watchedBuildings.length > 0) {
      this.addLabel(leftCol, y, '--- BATIMENTS SURVEILLES ---', '#ff6b35', '13px');
      y += 22;

      for (const wb of pi.watchedBuildings) {
        const riskColor = wb.riskPercent < 40 ? '#4caf50' : wb.riskPercent < 70 ? '#ff9800' : '#ff4444';
        this.addLabel(leftCol + 10, y, `${wb.name}: ${wb.riskPercent.toFixed(0)}%`, riskColor, '11px');
        y += 18;
      }
      y += 10;
    }

    // Corruption section
    this.addLabel(leftCol, y, '--- CORROMPRE UN OFFICIER ---', '#ff6b35', '13px');
    y += 22;
    this.addLabel(leftCol, y, `Cout: $${pi.corruptionCost} (argent clean)`, '#aaaaaa', '12px');
    y += 18;
    this.addLabel(leftCol, y, `Probabilite de succes: ${pi.corruptionSuccessRate}%`, '#aaaaaa', '12px');
    y += 25;

    // Show list of businesses to corrupt
    if (pi.watchedBuildings.length > 0) {
      for (const wb of pi.watchedBuildings) {
        this.addButton(leftCol + 120, y, `[ Corrompre ${wb.name} ]`, '#ff6b6b', () => {
          socketManager.sendAction('CORRUPT_OFFICER', {
            targetBusinessId: wb.businessId,
            amount: pi.corruptionCost,
          });
          this.refreshAfterAction();
        });
        y += 30;
      }
    } else {
      this.addLabel(leftCol, y, 'Aucun commerce a corrompre', '#666666', '11px');
    }
    y += 45;

    // Reduce alert section
    this.addLabel(leftCol, y, '--- REDUIRE L\'ALERTE ---', '#ff6b35', '13px');
    y += 22;
    this.addLabel(leftCol, y, `Cout: $${pi.reduceAlertCost} (argent clean)`, '#aaaaaa', '12px');
    y += 18;

    const canReduce = pi.canReduceAlert;
    const reduceColor = canReduce ? '#4caf50' : '#666666';
    const reduceLabel = canReduce ? '[ Reduire -30 pts ]' : '[ Cooldown actif ]';
    this.addButton(leftCol + 100, y, reduceLabel, reduceColor, () => {
      if (canReduce) {
        socketManager.sendAction('REDUCE_ALERT', { amount: pi.reduceAlertCost });
        this.refreshAfterAction();
      }
    });

    // Draw police desk
    this.graphics.fillStyle(0x5d4037, 1);
    this.graphics.fillRect(width - 220, 130, 150, 60);

    // Badge on wall
    this.graphics.fillStyle(0x3a6bc4, 1);
    this.graphics.fillCircle(width - 145, 100, 20);
    this.graphics.fillStyle(0xffd700, 1);
    this.graphics.fillCircle(width - 145, 100, 10);

    // Filing cabinets
    this.graphics.fillStyle(0x666666, 1);
    this.graphics.fillRect(width - 220, 220, 45, 80);
    this.graphics.fillRect(width - 160, 220, 45, 80);
    this.graphics.fillRect(width - 100, 220, 45, 80);
  }

  bindEvents(): void {
    // No persistent handlers — buttons use refreshAfterAction
  }

  private refreshAfterAction(): void {
    socketManager.onceActionResult(() => {
      socketManager.sendAction('ENTER_BUILDING', { buildingId: this.building.id });
    });
  }
}
